const GlobalStyles = {
   flexBox: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
   }
}

export default GlobalStyles
